// extracted by mini-css-extract-plugin
module.exports = {"cell":"Breakdown_cell__2U_CC","prepaidFeesText":"Breakdown_prepaidFeesText__OtSiG"};